import {
  brandColors,
  neutralColors,
  textColors,
  systemSupportColors,
  phaseColors,
} from './commonsColors';
import breakPoints from './breakPoints';

const containerWidth = '1440px';

const commonsTheme = {
  colors: {
    brandColors,
    neutralColors,
    textColors,
    systemSupportColors,
    phaseColors,
  },
  breakPoints,
  containerWidth,
};

export default commonsTheme;
